// Audio is never stored (ADR 0005). Within this tab, the files of recently opened songs stay in
// memory so moving between songs doesn't ask for them again; a reload forgets them.

/** Original file bytes per song (compressed, a few MB each), least recently used first. */
const files = new Map<string, ArrayBuffer>();
const MAX_FILE_BYTES = 150 * 1024 * 1024;

/** The most recently decoded song (decoded audio is large: ~85 MB for 4 min of stereo). */
let decoded: { songId: string; buffer: AudioBuffer } | null = null;

export function rememberFile(songId: string, bytes: ArrayBuffer): void {
  files.delete(songId);
  files.set(songId, bytes);
  let total = 0;
  for (const b of files.values()) total += b.byteLength;
  for (const [id, b] of files) {
    if (total <= MAX_FILE_BYTES || id === songId) break;
    files.delete(id);
    total -= b.byteLength;
  }
}

export function recallFile(songId: string): ArrayBuffer | null {
  const bytes = files.get(songId);
  if (!bytes) return null;
  files.delete(songId);
  files.set(songId, bytes);
  return bytes;
}

export function hasAudioInSession(songId: string): boolean {
  return files.has(songId) || decoded?.songId === songId;
}

export function rememberDecoded(songId: string, buffer: AudioBuffer): void {
  decoded = { songId, buffer };
}

export function recallDecoded(songId: string): AudioBuffer | null {
  return decoded?.songId === songId ? decoded.buffer : null;
}

/** Tests only. */
export function forgetSessionAudio(): void {
  files.clear();
  decoded = null;
}
